import { useEffect } from 'react';
import { useUnsavedChangesContext } from '../contexts/UnsavedChangesContext';

// Registers this page's dirty state with the global Escape-to-go-back guard
export function useUnsavedChanges(isDirty) {
  const { setDirty } = useUnsavedChangesContext();

  useEffect(() => {
    setDirty(isDirty);
  }, [isDirty, setDirty]);

  useEffect(() => {
    return () => setDirty(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
